import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { LightspeedCustomerGroup } from '../../../../../../../models/organization-config';


@Component({
  selector: 'app-set-lightspeed-customer-groups-managed-by-capitan-modal',
  templateUrl: './set-lightspeed-customer-groups-managed-by-capitan-modal.component.html',
  styleUrls: ['./set-lightspeed-customer-groups-managed-by-capitan-modal.component.css']
})
export class SetLightspeedCustomerGroupsManagedByCapitanModalComponent implements OnInit {
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public lightspeedCustomerGroupList: LightspeedCustomerGroup[];

  public loadingLightspeedCustomerGroups = true;
  public loadingSave = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {}

  ngOnInit() {
    this.loadLightspeedCustomerGroups();
  }

  public handleSubmit() {
    if (this.loadingLightspeedCustomerGroups) { return; }

    this.loadingSave = true;
    this.errorMessage = '';

    this.orgConfigService
      .setLightspeedCustomerGroupsManagedByCapitan(this.lightspeedCustomerGroupList)
      .then(() => {
        this.savedCallback({
          text: 'Lightspeed customer groups updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to configure Lightspeed customer groups.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

  private loadLightspeedCustomerGroups(): Promise<void> {
    this.loadingLightspeedCustomerGroups = true;

    return this.orgConfigService
      .syncLightspeedCustomerGroups()
      .then(() => {
        return this.orgConfigService.getLightspeedCustomerGroups();
      })
      .then(response => {
        this.lightspeedCustomerGroupList = response;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to configure Lightspeed customer groups.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingLightspeedCustomerGroups = false; });
  }

}
